import styled from 'styled-components';
import { Button } from 'antd';
import { COLORS } from '../../constants/colors';

export const StatusButton = styled(Button)`
  height: 40px;
  border-radius: 20px;
  border: 1px solid ${COLORS.border};
  background: white;
  padding: 0 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: ${COLORS.$primaryBlue};
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);
  }
  
  &:focus {
    border-color: ${COLORS.$primaryBlue};
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
`;

export const StatusDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${props => props.color};
  flex-shrink: 0;
  box-shadow: 0 0 8px ${props => props.color}40;
  animation: ${props => props.color === '#ff4d4f' ? 'pulse 2s infinite' : 'none'};
  
  @keyframes pulse {
    0% {
      box-shadow: 0 0 8px ${props => props.color}40;
    }
    50% {
      box-shadow: 0 0 16px ${props => props.color}60;
    }
    100% {
      box-shadow: 0 0 8px ${props => props.color}40;
    }
  }
`;

export const StatusText = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.textDark};
  white-space: nowrap;
`;

export const TimerDisplay = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${COLORS.textMedium};
  background: ${COLORS.backgroundLight};
  padding: 2px 8px;
  border-radius: 10px;
  font-family: 'Courier New', monospace;
  min-width: 45px;
  text-align: center;
`;

export const ConfigRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ConfigLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.textDark};
  margin-bottom: 4px;
`;
